import { Box, Button, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { InputKit } from '../../components/UI';
import { AuthService } from '../../Service/AuthService';
import { useAppDispatch } from '../../store/hooks';
import { createNotification } from '../../store/notifications/notification-slice';
export interface IFormInput {
  password: string;
  confirmPassword: string;
}

const ResetPassword = () => {
  const { resetId } = useParams<{
    resetId: string;
  }>();
  const methods = useForm<IFormInput>();
  const { handleSubmit, watch, setError } = methods;
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();

  const changePassword = async (values: IFormInput) => {
    try {
      await AuthService.changePassword({
        id: resetId!,
        ...values,
      });

      navigate('/');

      appDispatch(
        createNotification({
          message: 'Password changed successfully!',
          type: 'success',
        })
      );
    } catch (error) {
      appDispatch(
        createNotification({
          message: 'Something went wrong!',
          type: 'error',
        })
      );
    }
  };

  return (
    <FormProvider {...methods}>
      <Box
        sx={{
          maxWidth: '100%',
          width: '100%',
          display: 'flex',
          padding: '20px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <form
          action=''
          style={{
            maxWidth: '472px',
            width: '100%',
          }}
        >
          <Box
            bgcolor={'#fff'}
            display={'flex'}
            flexDirection={'column'}
            p={'24px'}
            sx={{ boxShadow: '0px 2px 20px  rgba(29, 49, 55, 0.12)' }}
            borderRadius={'4px'}
            gap={'24px'}
          >
            <Typography variant='h1'>Reset your password</Typography>
            <>
              <Typography
                color={'#736977'}
                fontSize={'14px'}
                fontWeight={'500'}
                lineHeight={'17px'}
              >
                Please enter your new password
              </Typography>
              <InputKit
                name={'password'}
                type={'password'}
                placeholder='Password'
                validation={{
                  required: {
                    value: true,
                    message: 'Password is required',
                  },
                  minLength: {
                    value: 8,
                    message: 'Password must have at least 8 characters',
                  },
                }}
              />

              <InputKit
                name={'confirmPassword'}
                type={'password'}
                placeholder='Confirm password'
                validation={{
                  required: {
                    value: true,
                    message: 'Confirm password is required',
                  },

                  onChange(event) {
                    setError('confirmPassword', {
                      type: 'required',
                      message:
                        event.target.value !== watch('password')
                          ? 'Passwords do not match'
                          : '',
                    });
                  },
                }}
              />
              <Button
                sx={{
                  background: '#3293DB',
                  color: '#fff',
                  maxWidth: '100%',
                  boxShadow: 'unset',
                  fontSize: '14px',
                  lineHeight: '17px',
                }}
                onClick={handleSubmit(changePassword)}
                type='submit'
                variant='contained'
              >
                Change Password
              </Button>
            </>
          </Box>
        </form>
      </Box>
    </FormProvider>
  );
};

export default ResetPassword;
